<template>
    <div class="ProjectMaterialList">
        <div v-for="(materialRate, index) in materialRates" :key="index" class="materialItem">
            <div class="materialItemMain">
                <div>
                    <FormSelectMaterial
                        :value.number="materialRate.materialId"
                        label="Material"
                        @input="handleUpdateMaterialRate(index, { materialId: $event })"
                    />
                </div>
                <div>
                    <FormSelect
                        :value="materialRate.type"
                        label="Type"
                        @input="handleUpdateMaterialRate(index, { type: $event })"
                    >
                        <option value="tons">Tons</option>
                        <option value="loads">Loads</option>
                    </FormSelect>
                </div>
                <div>
                    <FormCurrency
                        label="Rate"
                        :value="materialRate.rate"
                        :min="0"
                        @input="handleUpdateMaterialRate(index, { rate: $event })"
                    />
                </div>
            </div>

            <div class="deleteBtn" @click="handleRemoveMaterialRate(index)">
                <Icon name="trash" />
            </div>
        </div>

        <div v-if="!materialRates.length" class="empty">No material rates have been added yet.</div>

        <div v-if="hasMaterialConflicts" class="error">Warning: You have multiple rates for the same material.</div>

        <Button class="outline" @click="handleAddMaterialRate">Add Material</Button>
    </div>
</template>

<script>
import FormSelectMaterial from '@/components/common/FormSelectMaterial';

export default {
    name: 'ProjectMaterialList',

    components: { FormSelectMaterial },

    props: {
        materialRates: { type: Array, default: [] },
    },

    computed: {
        hasMaterialConflicts() {
            const materials = new Set();
            for (const materialRate of this.materialRates) {
                if (materials.has(materialRate.materialId)) {
                    return true;
                }

                materials.add(materialRate.materialId);
            }

            return false;
        },
    },

    methods: {
        handleAddMaterialRate() {
            this.updateMaterialRates([
                ...this.materialRates,
                { materialId: null, type: 'tons', rate: 0 },
            ]);
        },

        handleRemoveMaterialRate(index) {
            const materialRates = this.materialRates.filter((_, i) => i !== index);
            this.updateMaterialRates(materialRates);
        },

        handleUpdateMaterialRate(index, update) {
            this.updateMaterialRates(this.materialRates.map((materialRate, i) => {
                if (i !== index) return materialRate;
                return { ...materialRate, ...update };
            }));
        },

        updateMaterialRates(materialRates) {
            this.$emit('update:materialRates', materialRates);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ProjectMaterialList {
    .materialItem {
        display: flex;
        align-items: center;

        .materialItemMain {
            display: flex;
            flex: 1;

            & > div {
                flex: 1;
                margin-right: $grid-gutter-width;
            }
        }

        .deleteBtn {
            opacity: 0.25;
            cursor: pointer;

            &:hover {
                color: $red-color;
                opacity: 1;
            }
        }
    }

    .deleteBtn {
        display: inline-block;
    }

    .FormInputContainer {
        margin-bottom: $grid-gutter-width;
    }

    .Button {
        display: block;
        margin-left: auto;
    }

    .empty {
        margin: 15px 0;
        text-align: center;
        font-size: 18px;
    }

    .error {
        color: $red-color;
    }
}
</style>
